import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const HoneycombSkylight = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patterUrl = getPatternImages(state);

  const railColour = state.context.custom.railColour
    ? state.context.custom.railColour
    : 'White';
  const railColourHex = getHoneycombRailHexColour(railColour);

  const [width, height] = state.context.custom.measurements
    ? (state.context.custom.measurements as string)
        .split('x')
        .map(value => parseInt(value))
    : [0, 0];

  const squareMetreSize = (width * height) / 1000000;

  if (width < 1270 && squareMetreSize < 2.6) {
    return (
      <svg viewBox="0 0 554.2 420" {...props} preserveAspectRatio="none">
        <defs>
          <pattern
            id="hcSkylight"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patterUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1"
            x1={277.11}
            y1={28.06}
            x2={277.11}
            y2={10}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <style>
            {`.prefix__cls-2{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-3{fill:${railColourHex}}`}
          </style>
        </defs>
        <g id="prefix__Blind">
          <path fill="url(#hcSkylight)" d="M5 10h544.21v251.48H5z" />
          <path
            className="prefix__cls-2"
            d="M523.04 405.76V261.48M31.18 405.76V261.48"
          />
          <path
            className="prefix__cls-3"
            d="M0 0h554.21v10H0zM2.58 256.48h549.06v5H2.58z"
          />
          <path
            fill="url(#prefix__New_Gradient_Swatch_1)"
            d="M5 10h544.21v18.06H5z"
          />
          <path className="prefix__cls-3" d="M0 405.76h554.21v3.29H0z" />
        </g>
      </svg>
    );
  } else {
    return (
      <svg viewBox="0 0 554.2 420" {...props} preserveAspectRatio="none">
        <defs>
          <pattern
            id="hcSkylight"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patterUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1"
            x1={277.11}
            y1={28.06}
            x2={277.11}
            y2={10}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <style>
            {`.prefix__cls-2{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-3{fill:${railColourHex}}`}
          </style>
        </defs>
        <g id="prefix__Blind">
          <path fill="url(#hcSkylight)" d="M5 10h544.21v251.48H5z" />
          <path
            className="prefix__cls-2"
            d="M523.04 405.76V261.48M31.18 405.76V261.48"
          />
          <path
            className="prefix__cls-3"
            d="M0 0h554.21v10H0zM2.58 256.48h549.06v5H2.58z"
          />
          <path
            fill="url(#prefix__New_Gradient_Swatch_1)"
            d="M5 10h544.21v18.06H5z"
          />
          <path className="prefix__cls-2" d="M275.53 405.76V261.48" />
          <path className="prefix__cls-3" d="M0 405.76h554.21v3.29H0z" />
        </g>
      </svg>
    );
  }
};
